<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc" role="doc-toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">Preface</a></div>
<div class="SOM_pre"><a href="#/pre3">Introduction: Why a Pentecostal Guide to the Holy Spirit?</a></div>
<div class="SOM_chap"><a href="#/chap1"><span class="mev1">1</span> The Holy Spirit in Matthew<br/><span class="mev2">
    HALLMARK OF THE KINGDOM</span></a></div>
<div class="SOM_chap"><a href="#/chap2"><span class="mev1">2</span> The Holy Spirit in Mark<br/><span class="mev2">
    AUTHORITY AND OBEDIENCE</span></a></div>
<div class="SOM_chap"><a href="#/chap3"><span class="mev1">3</span> The Holy Spirit in Luke<br/><span class="mev2">
    GOOD NEWS FOR THE POOR AND FREEDOM FOR THE CAPTIVES</span></a></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample"><span class="mev1">4</span> The Holy Spirit in John<br/><span class="mev2">
    THE SPIRIT OF TRUTH</span></span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><span class="mev1">5</span> The Holy Spirit in Acts<br/><span class="mev2">
    A PROMISE KEPT</span></span></div>
<div class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample"><span class="mev1">6</span> The Holy Spirit in Romans<br/><span class="mev2">
    THE SPIRIT OF ADOPTION</span></span></div>
<div class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample"><span class="mev1">7</span> The Holy Spirit in 1 Corinthians<br/><span class="mev2">
    THE SPIRIT OF WISDOM AND GRACE</span></span></div>
<div class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample"><span class="mev1">8</span> The Holy Spirit in 2 Corinthians<br/><span class="mev2">
    THE SPIRIT OF THE NEW COVENANT</span></span></div>
<div class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample"><span class="mev1">9</span> The Holy Spirit in Galatians<br/><span class="mev2">
    THE SPIRIT OF FREEDOM</span></span></div>
<div class="SOM_chap"><span href="#/chap10" title="Link target outside of Sample"><span class="mev1">10</span> The Holy Spirit in Ephesians, Colossians, and Philemon<br/><span class="mev2">
    THE SPIRIT OF WISDOM AND REVELATION</span></span></div>
<div class="SOM_chap"><span href="#/chap11" title="Link target outside of Sample"><span class="mev1">11</span> The Holy Spirit in Philippians<br/><span class="mev2">
    THE SPIRIT OF JOY </span></span></div>
<div class="SOM_chap"><span href="#/chap12" title="Link target outside of Sample"><span class="mev1">12</span> The Holy Spirit in 1 and 2 Thessalonians<br/><span class="mev2">
    ESCHATOLOGY AND ETHICS</span></span></div>
<div class="SOM_chap"><span href="#/chap13" title="Link target outside of Sample"><span class="mev1">13</span> The Holy Spirit in the Pastoral Epistles<br/><span class="mev2">
    THE SPIRIT OF POWER, LOVE, AND SELF-CONTROL</span></span></div>
<div class="SOM_chap"><span href="#/chap14" title="Link target outside of Sample"><span class="mev1">14</span> The Holy Spirit in Hebrews<br/><span class="mev2">
    THE TESTIMONY OF THE SPIRIT</span></span></div>
<div class="SOM_chap"><span href="#/chap15" title="Link target outside of Sample"><span class="mev1">15</span> The Holy Spirit in James<br/><span class="mev2">
    THE WISDOM OF GOD </span></span></div>
<div class="SOM_chap"><span href="#/chap16" title="Link target outside of Sample"><span class="mev1">16</span> The Holy Spirit in 1 and 2 Peter<br/><span class="mev2">
    GOD'S ANSWER TO SUFFERING FOR CHRIST</span></span></div>
<div class="SOM_chap"><span href="#/chap17" title="Link target outside of Sample"><span class="mev1">17</span> The Holy Spirit in the Johannine Epistles<br/><span class="mev2">
    THE SPIRIT OF LIGHT AND LOVE</span></span></div>
<div class="SOM_chap"><span href="#/chap18" title="Link target outside of Sample"><span class="mev1">18</span> The Holy Spirit in Jude<br/><span class="mev2">
    PRAYING IN THE SPIRIT</span></span></div>
<div class="SOM_chap"><span href="#/chap19" title="Link target outside of Sample"><span class="mev1">19</span> The Holy Spirit in Revelation<br/><span class="mev2">
    THE SPIRIT OF PROPHECY</span></span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Final Thoughts</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Scripture Index</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">Praise for <i>The Holy Spirit in the New Testament</i></span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?88f973b8